module.exports = __webpack_public_path__ + "img/5.26d08b69.png";